export default "__VITE_ASSET__DpcPIO3R__"